module.exports = __webpack_public_path__ + "static/media/Header 6.7c75cfc5.svg";